
import { CrudModel } from "../../CrudModel";

export default {
  props: {
    model: {
      type: CrudModel,
      required: true
    },
    saveRequestOptions: {
      type: Object,
      default: () => ({})
    },
    requiresValidation: {
      type: Boolean,
      default: false
    },
    requiresUnsavedChanges: {
      type: Boolean,
      default: false
    },
    // Opt-in: gates on the FIELD-level rules the rendered layout carries,
    // not just model.isValid's property-level rules. Default off so the
    // other call sites (CrudModelActions, CrudModal, the Expert forms) keep
    // today's property-only behaviour.
    requiresFieldValidation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    invalidFields() {
      return this.requiresFieldValidation
        ? this.model.getModelLayout().invalidFields
        : [];
    },
    buttonDisabled() {
      if (this.requiresValidation && !this.model.isValid) {
        return true;
      }

      if (this.requiresUnsavedChanges && !this.model.hasUnsavedChanges) {
        return true;
      }

      if (this.invalidFields.length) {
        return true;
      }

      return false;
    },
    tooltipDisabled() {
      return !this.buttonDisabled;
    },
    tooltipMessage() {
      if (this.invalidFields.length) return "These fields are invalid:";

      return !this.model.hasUnsavedChanges
        ? "No changes to save"
        : "These fields are invalid:";
    },
    tooltipColor() {
      if (this.invalidFields.length) return "error";

      return !this.model.hasUnsavedChanges ? "grey darken-2" : "error";
    },
    iconOverride() {
      if (!this.model.isValid) return "mdi-alert-octagon-outline";
    }
  }
};
